import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'iv-filters',
  styleUrl: 'iv-filters.scss',
  shadow: true,
})
export class IvFilters {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
